<form [formGroup]="form" novalidate class="place-filters-form">
  <div class="border-1 surface-border border-round mb-4 p-fluid">
    <span class="text-900 font-bold block border-bottom-1 surface-border p-3">{{ 'places.filters.name' | translate }}</span>
    <div class="p-2"><input pInputText formControlName="name" [placeholder]="'places.filters.name' | translate" /></div>
  </div>

  <div class="border-1 surface-border border-round mb-4">
    <span class="text-900 font-bold block border-bottom-1 surface-border p-3">{{ 'places.filters.category' | translate }}</span>
    <div class="p-2">
      <span class="text-sm text-color-secondary block mb-2">{{ 'places.filters.main_category' | translate }}</span>
      <div class="place-category-pills" role="group" [attr.aria-label]="'places.filters.main_category' | translate">
        <button *ngFor="let category of rootCategories" type="button" pButton pRipple
                class="place-category-pill"
                [class.place-category-pill--selected]="isParentCategorySelected(category)"
                [style.border-color]="categoryColor(category)"
                [style.background-color]="isParentCategorySelected(category) ? categoryColor(category) : null"
                (click)="toggleParentCategory(category)">
          {{ placeLabels.category(category) }}
        </button>
      </div>
      <ng-container *ngIf="parentCategories.length">
        <span class="text-sm text-color-secondary block mt-3 mb-2">{{ 'places.filters.category' | translate }}</span>
        <div class="place-category-pills" role="group" [attr.aria-label]="'places.filters.category' | translate">
          <button *ngFor="let category of childCategories" type="button" pButton pRipple
                  class="place-category-pill"
                  [class.place-category-pill--selected]="isCategorySelected(category)"
                  [style.border-color]="categoryColor(category)"
                  [style.background-color]="isCategorySelected(category) ? categoryColor(category) : null"
                  (click)="toggleCategory(category)">
            {{ placeLabels.category(category) }}
          </button>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="border-1 surface-border border-round mb-4">
    <span class="text-900 font-bold block border-bottom-1 surface-border p-3">{{ 'places.filters.location' | translate }}</span>
    <div class="grid p-2">
      <div class="col-12 p-fluid">
        <p-autoComplete #placeAddress formControlName="address" appendTo="body" [placeholder]="'places.filters.location_placeholder' | translate" [suggestions]="searchResults" (completeMethod)="searchPlaces($event)" (onSelect)="selectPlace($event)" (onUnselect)="unselectPlace($event)" (onClear)="clearPlaceSelection()" [minLength]="2" [delay]="500" [multiple]="true" [optionLabel]="getAddressOptionLabel" [optionValue]="getAddressOptionValue" [forceSelection]="true">
          <ng-template let-result pTemplate="item"><div class="text-white">{{ result.label }}</div></ng-template>
          <ng-template let-result pTemplate="selectedItem"><div class="text-white">{{ result.label }}</div></ng-template>
          <ng-template pTemplate="loadingicon">
            <span class="app-loading-ring" aria-hidden="true"></span>
          </ng-template>
        </p-autoComplete>
      </div>
      <div class="col-12 p-fluid">
        <label class="text-sm">{{ 'places.filters.radius' | translate }}: {{ form.get('radius')?.value }} km</label>
        <div class="mt-3"><p-slider formControlName="radius" [step]="5" [min]="1" [max]="5000" styleClass="w-full" (onChange)="updateRadius()"></p-slider></div>
      </div>
      <div class="col-12"><app-map [active]="mapActive" [lat]="initialCenter.lat" [lon]="initialCenter.lon" [markers]="initialMarker ? [initialMarker] : []" [zoom]="initialMarker ? 11 : 5" [contentReady]="true" [allowScrollWheelZoom]="true" [draggable]="true" (mapReady)="onMapReady()" (mapClicked)="selectMapPoint($event)"></app-map></div>
    </div>
  </div>
</form>
